import React, { useState } from 'react';
import { useLocation, Router } from 'react-router-dom';
import DefinitionHandleSelect from 'Utils/DefinitionHandleSelect';
import DefinitionHandleSelectAll from 'Utils/DefinitionHandleSelectAll';
import SideBarContainer from 'Containers/SideBarContainer';
import useCourse from './Hooks/useCourse';
import Search from '../../Components/Search';
import Title from '../../Components/Title';
import DropDown from '../../Components/DropDown';
import { containerEmployee, searchContainer, findContainer } from './style';
import useDropDown from './Hooks/useDropdown';
import useComponent from './Hooks/useComponent';
import useTranslation from '../../Hooks/useTranslation';
import SelectTable from '../../Components/SelectTable';

export default function DefinitionEnterprise() {
  const location = useLocation();
  if (location?.state?.isComingFrom !== '/definicion') {
    return <Router to="/definicion" />;
  }
  const [isLoading, setIsLoading] = useState(true);
  const { courses, setCourses, categories, setCategories, saveCourses, defaultSelectedIds } = useCourse(setIsLoading);
  const { setSearch, setCategory, coursesFilters } = useDropDown({
    courses,
  });
  const { thereIsComponent } = useComponent({ categories });
  const { t2 } = useTranslation('DefinitionEnterprise');
  const titles = [t2('Category')];
  const options = [categories];
  const methods = [setCategory];
  const [selectedRows, setSelectedRows] = useState([]);
  const [unselectedRows, setUnselectedRows] = useState([]);
  const [selectAllItems, setSelectAllItems] = useState(false);

  const disableButton = () => {
    if (defaultSelectedIds.length <= 0) {
      return !selectedRows.length > 0;
    }

    return !(selectedRows.length > 0 || unselectedRows.length > 0);
  };

  const handleSelect = (row, indx) => {
    const argPayload = {
      defaultSelectedIds,
      unselectedRows,
      selectedRows,
      setSelectedRows,
      setUnselectedRows,
      courseList: coursesFilters,
    };
    DefinitionHandleSelect(row, indx, 4, argPayload);
  };

  const handleSelectAll = () => {
    const argPayload = {
      courseList: coursesFilters,
      defaultSelectedIds,
      setUnselectedRows,
      setSelectedRows,
      setSelectAllItems,
      selectAllItems,
      unselectedRows,
    };
    DefinitionHandleSelectAll(4, argPayload);
  };

  return (
    <SideBarContainer>
      <div style={containerEmployee}>
        <Title
          title={t2('Title')}
          subtitle={t2('SubTitle')}
          textButton={t2('ButtonSave')}
          eventButton={() => saveCourses(selectedRows.concat(unselectedRows))}
          disabledButton={disableButton()}
        />
        <div style={searchContainer}>
          <div style={{ width: '40%' }}>
            <Search setData={setSearch} placeholder={t2('Search')} />
          </div>
          <div style={findContainer}>
            {titles.map((title, index) => {
              const id = title + index;
              return <DropDown key={id} title={title} options={options[index]} setData={methods[index]} />;
            })}
          </div>
        </div>
        <SelectTable
          information={coursesFilters}
          headers={[t2('Name'), t2('Terminal'), t2('TimeCourse'), t2('Category')]}
          limit={4}
          thereIsComponent={thereIsComponent}
          floatingMessage={t2('SelectedCourses')}
          selectedRows={selectedRows}
          event={handleSelect}
          selectAllEvent={handleSelectAll}
          selectAllStatus={selectAllItems}
          isLoading={isLoading}
        />
      </div>
    </SideBarContainer>
  );
}
